import { updateDiagramInfluenceAnalysis as updateDiagramInfluenceAnalysisDiagram } from '@process-advisor/process-miner/processMiner/processMiner';

import { openProgressModal } from '@process-advisor/process-miner/api/methods/modals/openProgressModal';
import { closeProgressModal } from '@process-advisor/process-miner/api/methods/modals/closeProgressModal';


export async function updateDiagramInfluencers  () {
    const sleep = ms => new Promise(r => setTimeout(r, ms));

    await openProgressModal({status: 'Processing Clusters'})
    await sleep(50)
    updateDiagramInfluenceAnalysisDiagram('');
    closeProgressModal()

};

